import React, {
    ChangeEvent,
    Component,
    KeyboardEvent,
    MouseEvent,
    TouchEvent,
} from "react";
import classnames from "classnames";
import { observer } from "mobx-react";

import { NumberField } from "./NumberField";
import * as styles from "./Slider.scss";

export type SliderOrientation = "horizontal" | "vertical";

export interface ISliderProps {
    value: number;
    min: number;
    max: number;
    step?: number;
    currentValue?: number;
    orientation: SliderOrientation;
    hideValues?: boolean;
    hasNumberField?: boolean;
    className?: string;
    rangeClassName?: string;
    numberFieldClassName?: string;
    disabled?: boolean;
    onSliderChange: (value: number | undefined) => void;
    onInputChange: (value: number | undefined) => void;
    onInputBlur?: () => void;
    onMouseUp?: () => void;
}

@observer
export class Slider extends Component<ISliderProps> {
    public render() {
        const {
            orientation,
            min,
            max,
            step,
            value,
            currentValue,
            hideValues,
            hasNumberField,
            className,
            rangeClassName,
            numberFieldClassName,
            disabled,
            onInputChange,
            onInputBlur,
        } = this.props;

        return (
            <div
                className={classnames(
                    styles.slider,
                    styles[orientation],
                    disabled && styles.disabled,
                    className,
                )}
            >
                <div
                    className={classnames(
                        styles["range-container"],
                        rangeClassName,
                    )}
                >
                    {!hideValues && <div className={styles.min}>{min}</div>}
                    <div className={styles.range}>
                        {currentValue !== undefined && (
                            <input
                                type="range"
                                min={min !== undefined ? min : -1}
                                max={max !== undefined ? max : 1}
                                value={currentValue}
                                className={classnames(
                                    styles.range,
                                    styles.ghost,
                                )}
                                step={0.001}
                                disabled={true}
                                readOnly={true}
                            />
                        )}
                        <input
                            type="range"
                            min={min !== undefined ? min : -1}
                            max={max !== undefined ? max : 1}
                            step={
                                step === undefined
                                    ? 0.1
                                    : step === 0
                                      ? "any"
                                      : step
                            }
                            value={value}
                            className={styles.range}
                            onChange={this.onSliderChange}
                            onMouseUp={this.onMouseUp}
                            onTouchEnd={this.onTouchEnd}
                        />
                    </div>

                    {!hideValues && <div className={styles.max}>{max}</div>}
                </div>
                {hasNumberField && (
                    <NumberField
                        numberValue={value}
                        small={true}
                        className={classnames(
                            styles.field,
                            numberFieldClassName,
                        )}
                        onChangeNumber={onInputChange}
                        onBlur={onInputBlur}
                        onKeyDown={this.onKeyDown}
                    />
                )}
            </div>
        );
    }

    private onMouseUp = (_: MouseEvent) => {
        this.props.onMouseUp?.();
    };

    private onTouchEnd = (_: TouchEvent) => {
        this.props.onMouseUp?.();
    };

    private onSliderChange = (event: ChangeEvent<HTMLInputElement>) => {
        this.props.onSliderChange(event.target.valueAsNumber);
    };

    private onKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter" && this.props.onInputBlur) {
            this.props.onInputBlur();
        }
    };
}
